import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';

import { CaNumber, SingleCaNumberDetails, UpdateCaNumberPayload } from './ca-numbers.model';

@Injectable({ providedIn: 'root' })
export class CaNumbersService {
  constructor(private http: HttpClient) {}

  getCaNumbers(params: { q?: string; offset?: number; limit?: number; sort?: string }) {
    let httpParams = new HttpParams()
      .set('offset', (params.offset ?? 0).toString())
      .set('limit', params.limit?.toString() ?? '10')
      .set('sort', params.sort ?? 'id');
    if (params.q) {
      httpParams = httpParams.set('q', params.q);
    }
    return this.http
      .get<
        CaNumber[]
      >(`${environment.apiUrl}/ca-numbers`, { params: httpParams, observe: 'response' })
      .pipe(
        map((resp: HttpResponse<CaNumber[]>) => ({
          caNumbers: resp.body ?? [],
          total: +(resp.headers.get('x-total-count') ?? '0'),
        })),
      );
  }

  deleteCaNumber(id: number) {
    return this.http.delete(`${environment.apiUrl}/ca-numbers/${id}`);
  }

  getCaNumberById(id: number): Observable<SingleCaNumberDetails> {
    return this.http.get<SingleCaNumberDetails>(`${environment.apiUrl}/ca-numbers/${id}`);
  }

  updateCaNumber(id: number, payload: UpdateCaNumberPayload) {
    return this.http.put<SingleCaNumberDetails>(`${environment.apiUrl}/ca-numbers/${id}`, payload);
  }

  addCaNumber(payload: UpdateCaNumberPayload) {
    return this.http.post<SingleCaNumberDetails>(`${environment.apiUrl}/ca-numbers`, payload);
  }
}
